import { Component, Input } from "@angular/core"

@Component({
    selector: "table-tooltip",
    templateUrl: "./table-tooltip.component.html",
    styleUrl: "./table-tooltip.component.scss",
})
export class TableTooltipComponent {
    @Input()
    public text: string
    @Input()
    public tooltip: string
}
